
/* VOUCHER */
export const GET_VOUCHER_LISTING = "GET_VOUCHER_LISTING";
export const GET_VOUCHER_LISTING_SUCCESS = "GET_VOUCHER_LISTING_SUCCESS";
export const GET_VOUCHER_LISTING_FAIL = "GET_VOUCHER_LISTING_FAIL";

export const GET_VOUCHER_DETAILS = "GET_VOUCHER_DETAILS";
export const GET_VOUCHER_DETAILS_SUCCESS = "GET_VOUCHER_DETAILS_SUCCESS";
export const GET_VOUCHER_DETAILS_FAIL = "GET_VOUCHER_DETAILS_FAIL";

export const ADD_VOUCHER = "ADD_VOUCHER";
export const ADD_VOUCHER_SUCCESS = "ADD_VOUCHER_SUCCESS";
export const ADD_VOUCHER_FAIL = "ADD_VOUCHER_FAIL";

export const UPDATE_VOUCHER = "UPDATE_VOUCHER";
export const UPDATE_VOUCHER_SUCCESS = "UPDATE_VOUCHER_SUCCESS";
export const UPDATE_VOUCHER_FAIL = "UPDATE_VOUCHER_FAIL";

export const DELETE_VOUCHER = "DELETE_VOUCHER";
export const DELETE_VOUCHER_SUCCESS = "DELETE_VOUCHER_SUCCESS";
export const DELETE_VOUCHER_FAIL = "DELETE_VOUCHER_FAIL";

export const EXPORT_VOUCHER = "EXPORT_VOUCHER";
export const EXPORT_VOUCHER_SUCCESS = "EXPORT_VOUCHER_SUCCESS";
export const EXPORT_VOUCHER_FAIL = "EXPORT_VOUCHER_FAIL";

export const RESET_VOUCHER_ATTACHMENT_STATE = 'RESET_VOUCHER_ATTACHMENT_STATE';
export const RESET_VOUCHER_STATE = 'RESET_VOUCHER_STATE';